export default __webpack_public_path__ + "static/media/asphaltFront2.e778b4f9.png";